import noop from 'lodash/noop';
import {
	INITIALIZE_APP_PROPS,
	FETCH_AVATARS,
	FETCH_AVATARS_SUCCESS,
	FETCH_AVATARS_FAILURE,
	SAVE_AVATAR_IMAGE,
	SAVE_AVATAR_IMAGE_SUCCESS,
	SAVE_AVATAR_IMAGE_FAILURE,
	type Action,
} from './actions.tsx';
import type { State } from './types.tsx';

export const defaultState: State = {
	appProps: {
		projectId: 0,
		isOpen: false,
		selectedAvatar: undefined,
		onAvatarSelected: noop,
		onDismiss: noop,
	},
	isFetching: false,
	isSaving: false,
	fetchError: false,
	avatars: [],
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = defaultState, action: Action): State => {
	switch (action.type) {
		case INITIALIZE_APP_PROPS:
			return {
				...state,
				appProps: action.payload,
			};
		case FETCH_AVATARS:
			return {
				...state,
				isFetching: true,
				fetchError: false,
				avatars: defaultState.avatars,
			};
		case FETCH_AVATARS_SUCCESS:
			return {
				...state,
				isFetching: false,
				fetchError: false,
				avatars: action.payload,
			};
		case FETCH_AVATARS_FAILURE:
			return {
				...state,
				isFetching: false,
				fetchError: true,
			};
		case SAVE_AVATAR_IMAGE:
			return {
				...state,
				isSaving: true,
			};
		case SAVE_AVATAR_IMAGE_SUCCESS:
			return {
				...state,
				isSaving: false,
				avatars: [...state.avatars, action.payload.avatar],
			};
		case SAVE_AVATAR_IMAGE_FAILURE:
			return {
				...state,
				isSaving: false,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
